<!--  -->
<template>
  <user-center-wrap>
    <div class="center-anchor-up">
      <div class="anchor-titles">
        <div :class="{ active: isDataOverview }" class="title" @click="changeTitles('dataOverview')">
          <img src="../../assets/img/center-anchor/data_overview_on.png" alt="" v-if="isDataOverview" />
          <img src="../../assets/img/center-anchor/data_overview_nor.png" alt="" v-else />
          <span>数据概览</span>
        </div>
        <!-- <div :class="{ active: isMyFans }" class="title" @click="changeTitles('myFans')">
          <img src="../../assets/img/center-anchor/my_fans_on.png" alt="" v-if="isMyFans" />
          <img src="../../assets/img/center-anchor/my_fans_nor.png" alt="" v-else />
          <span>我的粉丝</span>
        </div> -->
        <div :class="{ active: isFrequency }" class="title" @click="changeTitles('frequency')">
          <img src="../../assets/img/center-anchor/frequency_on.png" alt="" v-if="isFrequency" />
          <img src="../../assets/img/center-anchor/frequency_nor.png" alt="" v-else />
          <span>直播场次</span>
        </div>
      </div>
    </div>
    <div class="center-anchor" v-if="isDataOverview">
      <div class="dataOverview-up">
        <div class="dataOverview-up-title">今日数据</div>
        <div class="dataOverview-up-content">
          <div class="content" v-for="(item, index) in totalDataOverview" :key="index" :style="item.style">
            <img :src="item.imgs" alt="" />
            <div class="content-text">
              <span class="content-text-title">{{ item.text }}</span>
              <span class="content-text-num">{{ item.num }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="dataOverview-down">
        <div class="dataOverview-down-title">
          <div class="left">前7日数据分析</div>
          <div class="block right" @click.once="changeInitCalendarPage">
            <el-date-picker
              v-model="timesOverview"
              type="daterange"
              size="mini"
              :picker-options="pickerOptions1"
              range-separator="~"
              format="yyyy/MM/dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="dataOverview-down-content">
          <div class="down-content-item-box">
            <div class="down-content-item">
              <div class="charts-title">克拉收益走势/克拉</div>
              <div ref="chart1" class="charts"></div>
            </div>
            <div class="down-content-item">
              <div class="charts-title">直播间观众数/人</div>
              <div ref="chart2" class="charts"></div>
            </div>
          </div>
          <div class="down-content-item-box">
            <div class="down-content-item">
              <div class="charts-title">新增粉丝走势/人</div>
              <div ref="chart3" class="charts"></div>
            </div>
            <div class="down-content-item">
              <div class="charts-title">直播场次走势/场</div>
              <div ref="chart4" class="charts"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center-anchor" v-else-if="isMyFans">
      <div class="myFans-box">
        <div class="myFans-up">
          <div class="myFans-up-left">
            <span :class="{ active: isTotalFans }" @click="chageMyFansBtn('totalFans')">累计粉丝</span>
            <span :class="{ active: isAddFans }" @click="chageMyFansBtn('addFans')">净增粉丝</span>
            <span :class="{ active: isLostFans }" @click="chageMyFansBtn('lostFans')">流失粉丝</span>
          </div>
          <div class="myFans-up-right block" @click.once="changeInitCalendarPage">
            <el-date-picker
              v-model="timesFans"
              type="daterange"
              size="mini"
              :picker-options="pickerOptions2"
              range-separator="~"
              format="yyyy/MM/dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="myFans-down">
          <div ref="chart5" class="charts5"></div>
        </div>
      </div>
    </div>
    <div class="center-anchor" v-else>
      <div class="frequency-box">
        <div class="block frequency-up" @click.once="changeInitCalendarPage">
          <el-date-picker
            v-model="timesFrequency"
            type="daterange"
            size="mini"
            :picker-options="pickerOptions3"
            range-separator="~"
            format="yyyy/MM/dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="frequency-down">
          <template>
            <el-table
              border
              :data="tableData"
              style="width: 100%"
              max-height="700"
              :header-cell-style="{ background: '#02A8A2', color: '#ffffff', fontSize: '.12rem', fontWeight: '500' }"
            >
              <el-table-column align="center" label="直播封面/名称"> 
                <template slot-scope="scope">
                  <img :src="scope.row.thumb" alt="" style="width: .20rem;height: 0.2rem;">
                  <span>
                       {{scope.row.title}}
                  </span>
              </template>
              </el-table-column>
              <el-table-column align="center" label="开播时间/时长">
              <template slot-scope="scope">
                  <span>
                       {{ moment(scope.row.time * 1000).format("YYYY-MM-DD HH:mm:ss") }} <br /> {{formatSeconds1(scope.row.duration)}}
                  </span>
              </template>
              </el-table-column>
              <el-table-column align="center" label="直播间观众/人" width="100">
                <template slot-scope="scope">
                  <span>
                      {{scope.row.visitor || 0}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="送礼人数" width="100">
                <template slot-scope="scope">
                  <span>
                      {{scope.row.gift_num || 0}}
                  </span>
                </template>
              </el-table-column>
              <!-- <el-table-column align="center" prop="text_num" label="评论人数" width="100"> </el-table-column> -->
              <el-table-column align="center" label="新增粉丝" width="100"> 
                <template slot-scope="scope">
                  <span>
                      {{scope.row.new_fans || 0}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="克拉收益" width="100"> 
                <template slot-scope="scope">
                  <span>
                      {{scope.row.diamond/100 || 0}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="收获鹰钻" width="100"> 
                <template slot-scope="scope">
                  <span>
                      {{scope.row.other_gift/100 || 0}}
                  </span>
                </template>
              </el-table-column>
              <div slot="empty">
                <Empty text="暂时没有直播数据" :imgWidth="250" :img="require('@/assets/img/empty/no-data.png')"></Empty>
              </div>
            </el-table>
          </template>
        </div>
      </div>
    </div>
  </user-center-wrap>
</template>

<script>
import UserCenterWrap from "../../components/user-center-wrap/user-center-wrap";
import { post } from "@/util/http";
import moment from "moment";
import Empty from "@/components/empty/empty";
import { dataset } from "dom7";

export default {
  name: "center-anchor",
  components: {
    UserCenterWrap,Empty
  },
  data() {
    return {
      moment: moment,
      tableData: [],
      timesOverview: "",
      timesFans: "",
      timesFrequency: "",
      isTotalFans: true,
      isAddFans: false,
      isLostFans: false,
      isDataOverview: true,
      isMyFans: false,
      isFrequency: false,
      toolTipText: "累计粉丝",
      fans: [],
      overView: {
        date: [],
        diamond: [],
        id: [],
        lost_fans: [],
        new_fans: [],
        times: [],
        total_fans: [],
        visitor: [],
        live_duration: [],
        other_gift: [],
      },
      dateA: [],
      size:7,
      totalDataOverview: [
        {
          style: "background: linear-gradient(90deg, #FFF3C9 0%, #FFEDE6 100%);",
          imgs: require("../../assets/img/center-anchor/income.png"),
          text: "克拉收益",
          num: "",
        },
        {
          style: "background: linear-gradient(90deg, #ECFFEC 0%, #E6FFFD 100%);",
          imgs: require("../../assets/img/center-anchor/other_gift.png"),
          text: "鹰钻收益",
          num: "",
        },
        {
          style: "background: linear-gradient(90deg, #E7FFF9 0%, #E2FED8 100%);",
          imgs: require("../../assets/img/center-anchor/audience.png"),
          text: "直播间观众",
          num: "",
        },
        {
          style: "background: linear-gradient(90deg, #FFF5EC 0%, #FFEEEE 100%);",
          imgs: require("../../assets/img/center-anchor/new_fans.png"),
          text: "新增粉丝",
          num: "",
        },
        {
          style: "background: linear-gradient(90deg, #F5F3FF 0%, #FAEDFF 100%);",
          imgs: require("../../assets/img/center-anchor/timer.png"),
          text: "开播时长",
          num: "",
        },
        {
          style: "background: linear-gradient(90deg, #E1F8FF 0%, #EEF3FF 100%);",
          imgs: require("../../assets/img/center-anchor/frequency.png"),
          text: "直播场次",
          num: "",
        },
      ],
      selectData: Date.now() - 3600 * 1000 * 24,
      pickerOptions1: {
        onPick: ({ maxDate, minDate }) => {
          this.selectData = minDate.getTime();
          if (maxDate) {
            let stastDate  = minDate.getTime();
            let endDate  = maxDate.getTime();
            let three = 6 * 24 * 3600 * 1000;
            if(endDate - stastDate > three) {
              stastDate = endDate - three
              this.size = 7
            } else {
              this.size = (endDate - stastDate)/(3600 * 1000 * 24)+1
            }
            minDate = moment(stastDate).format("YYYY-MM-DD");
            maxDate = moment(endDate).format("YYYY-MM-DD");
            this.$nextTick(() => {
            this.timesOverview = [minDate,maxDate]
            this.getAnchorInfo(this.timesOverview)
            })
          }
        },
        disabledDate: (time) => {
          if (!this.isNull(this.selectData)) {
            let curDate = new Date().getTime();
            let three = 31 * 24 * 3600 * 1000;
            let threeMonths = curDate - three;
            return time.getTime() > Date.now() - 3600 * 1000 * 24 || time.getTime() - 3600 * 1000 * 24 < threeMonths;
          } else {
            return false;
          }
        },
      },
      pickerOptions2: {
        onPick: ({ maxDate, minDate }) => {
          this.selectData = minDate.getTime();
          if (maxDate) {
            let stastDate  = minDate.getTime();
            let endDate  = maxDate.getTime();
            let three = 14 * 24 * 3600 * 1000;
            if(endDate - stastDate > three) {
              stastDate = endDate - three
              this.size = 15
            } else {
              this.size = (endDate - stastDate)/(3600 * 1000 * 24)+1
            }
            minDate = moment(stastDate).format("YYYY-MM-DD");
            maxDate = moment(endDate).format("YYYY-MM-DD");
            this.$nextTick(() => {
            this.timesFans = [minDate,maxDate]
            this.getAnchorInfo(this.timesFans)
            })
          }
        },
        disabledDate: (time) => {
          if (!this.isNull(this.selectData)) {
            let curDate = new Date().getTime();
            let three = 61 * 24 * 3600 * 1000;
            let threeMonths = curDate - three;
            return time.getTime() > Date.now() - 3600 * 1000 * 24 || time.getTime() - 3600 * 1000 * 24 < threeMonths;
          } else {
            return false;
          }
        },
      },
      pickerOptions3: {
        onPick: ({ maxDate, minDate }) => {
          this.selectData = minDate.getTime();
          if (maxDate) {
            let stastDate  = minDate.getTime();
            let endDate  = maxDate.getTime();
            let three = 6 * 24 * 3600 * 1000;
            if(endDate - stastDate > three) {
              stastDate = endDate - three
            }
            minDate = moment(stastDate).format("YYYY-MM-DD");
            maxDate = moment(endDate).format("YYYY-MM-DD");
            this.$nextTick(() => {
            this.timesFrequency = [minDate,maxDate]
            this.liveHistoryInfo(this.timesFrequency)
            })
          }
        },
        disabledDate: (time) => {
          if (!this.isNull(this.selectData)) {
            let curDate = new Date().getTime();
            let three = 31 * 24 * 3600 * 1000;
            let threeMonths = curDate - three;
            return time.getTime() > Date.now()|| time.getTime()< threeMonths;
          } else {
            return false;
          }
        },
      },
    };
  },
  created() {
    this.timesOverview = this.getNowTime(7,1);
    this.timesFans = this.getNowTime(15,1);
    this.timesFrequency = this.getNowTime(6,0);
  },
  mounted() {
    this.getAnchorInfo(this.timesOverview);
  },
  computed: {},
  watch: {},
  methods: {
    // onFocus(value){
    //     this.timesOverview = value
    // },
    changeInitCalendarPage() {
      let element = document.querySelector("button.el-picker-panel__icon-btn.el-icon-arrow-left");
        if (element) element.click();
    },
    formatSeconds(value) {
            var minuteTime = 0;
            var hourTime = 0;
            if(value > 60) {
                minuteTime = parseInt(value / 60);
                value = parseInt(value % 60);
                if( minuteTime > 60) {
                    hourTime = parseFloat(minuteTime / 60);
                    minuteTime = parseInt(minuteTime % 60);
                    if(hourTime >= 10) {
                      hourTime = Math.round(hourTime * 10) / 10
                    }
                }
            }
            var result = 0
            if(minuteTime > 0) {
                result = "" + parseInt(minuteTime) + "min";
            }
            if(hourTime > 0) {
                result = "" + parseInt(hourTime) + "h " + result;
            }
            if(hourTime >= 10) {
                result = "" + hourTime + "h";
            }
            return result;
        },
    formatSeconds1(value) {
            var minuteTime = 0;
            var hourTime = 0;
            if(value > 60) {
                minuteTime = parseInt(value / 60);
                value = parseInt(value % 60);
                if(minuteTime > 60) {
                    hourTime = parseInt(minuteTime / 60);
                    minuteTime = parseInt(minuteTime % 60);
                }
            }
            var result = ""
            if(minuteTime > 0) {
                result = "/时长" + parseInt(minuteTime) + "分钟";
            }
            if(hourTime > 0) {
                result = "/时长" + parseInt(hourTime) + "小时" + parseInt(minuteTime) + "分钟";
            }
            return result;
        },
    isNull(value) {
      if (value) {
        return false;
      }
      return true;
    },
    async getAnchorInfo(times) {
      if (!times) {
        times = [];
      }
      const {
        data: { data },
      } = await post({
        url: "/api/live/live_stat",
        data: {
          anchor_id: parseInt(this.$route.query.id),
          start_date: times[0],
          end_date: times[1],
          size:this.size
        },
      });
      this.totalDataOverview[0].num = data.today_summary.diamond/100 || 0;
      this.totalDataOverview[1].num = data.today_summary.other_gift/100 || 0;
      this.totalDataOverview[2].num = data.today_summary.visitor || 0;
      this.totalDataOverview[3].num = data.today_summary.new_fans || 0;
      this.totalDataOverview[4].num = this.formatSeconds(data.today_summary.live_duration);
      this.totalDataOverview[5].num = data.today_summary.times || 0;
      Object.getOwnPropertyNames(this.overView).forEach((key) => {
        this.overView[key].length = 0;
      });
      this.dateA.length = 0
      if(!data.live_stat) {
        data.live_stat = []
      }
        data.live_stat.forEach((item) => {
        this.overView.date.push(moment(item.date).format("YYYY-MM-DD"));
        this.dateA.push(moment(item.date).format("MM-DD"));
        this.overView.lost_fans.push(item.lost_fans || 0);
        this.overView.new_fans.push(item.new_fans || 0);
        this.overView.times.push(item.times || 0);
        this.overView.total_fans.push(item.total_fans || 0);
        this.overView.visitor.push(item.visitor || 0);
        this.overView.id.push(item.id || 0);
        this.overView.diamond.push(item.diamond / 100 || 0);
        this.overView.other_gift.push(item.other_gift / 100 || 0 );
        this.overView.live_duration.push(item.live_duration || 0);
      });
      this.getEchartData1();
      this.getEchartData2();
      this.getEchartData3();
      this.getEchartData4();
      this.getEchartData5();
    },
    async liveHistoryInfo(times) {
      if (!times) {
        times = [];
      }
      const {
        data: { data },
      } = await post({
        url: "/api/live/live_history",
        data: {
          anchor_id: parseInt(this.$route.query.id),
          start_date: times[0],
          end_date: times[1],
        },
      });
      let datas = data.live_hisgory || []
      this.tableData = datas.reverse()
    },
    getNowTime(day,days) {
      const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * day).toISOString().replace("T", " ").split(" ")[0];
        const end = new Date(new Date().getTime() - 3600 * 1000 * 24 * days).toISOString().replace("T", " ").split(" ")[0];
      return [start, end];
    },
    changeTitles(value) {
      if (value == "dataOverview") {
        this.isDataOverview = true;
        this.isMyFans = false;
        this.isFrequency = false;
        this.$nextTick(() => {
          this.size = 7
          this.getAnchorInfo(this.timesOverview);
        });
      } else if (value == "myFans") {
        this.isDataOverview = false;
        this.isMyFans = true;
        this.isFrequency = false;
        this.$nextTick(() => {
          this.size = 15
          this.chageMyFansBtn("totalFans");
        });
      } else if (value == "frequency") {
        this.isDataOverview = false;
        this.isMyFans = false;
        this.isFrequency = true;
        this.$nextTick(() => {
          this.liveHistoryInfo(this.timesFrequency);
        });
      }
    },
    chageMyFansBtn(value) {
      if (value == "totalFans") {
        this.isTotalFans = true;
        this.isAddFans = false;
        this.isLostFans = false;
        this.toolTipText = "累计粉丝";
        this.fans = this.overView.total_fans;
      } else if (value == "addFans") {
        this.isTotalFans = false;
        this.isAddFans = true;
        this.isLostFans = false;
        this.toolTipText = "净增粉丝";
        this.fans = this.overView.new_fans;
      } else if (value == "lostFans") {
        this.isTotalFans = false;
        this.isAddFans = false;
        this.isLostFans = true;
        this.toolTipText = "流失粉丝";
        this.fans = this.overView.lost_fans;
      }
      this.getAnchorInfo(this.timesFans);
    },
    getEchartData1() {
      const chart = this.$refs.chart1;
      if (chart) {
        const myChart = this.$echarts.init(chart);
        const option = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255, 214, 0, .9)",
            borderColor: "rgba(255, 193, 33, .6)",
            borderWidth: 2,
            textStyle: {
              color: "#fff",
              fontSize: 10,
              lineHeight: 1000,
            },
            formatter: (params) => {
              let dataStr = `<div><p style="font-weight:bold;margin:4px 0;text-align: center;">${params[0].name}</p></div>`;
              params.forEach((item) => {
                dataStr += `
        <div>
          <div style="text-align: center;margin-bottom:4px;">
            <span style="display:inline-block;margin-right:6px;">${item.seriesName}:</span>
            <span>${item.data}</span>
          </div>
        </div>`;
              });
              return dataStr;
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "3%",
            top: "5%",
            containLabel: true,
          },
          xAxis: {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
          },
          yAxis: {
            type: "category",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
            data: this.dateA,
          },
          series: [
            {
              name: "克拉收益",
              type: "bar",
              label: {
                show: true,
                position: "right",
                color: "#02A8A2",
              },
              itemStyle: {
                borderRadius: [0, 10, 10, 0],
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(41, 241, 156, 1)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(2, 161, 249, 1)", // 100% 处的颜色
                    },
                  ],
                },
              },
              barWidth: 12,
              data: this.overView.diamond,
            },
          ],
        };
      // if(this.overView.date.length == 0) {
      //  this.$nextTick(() => {
      //    chart.innerHTML = "暂无数据";
      //    chart.style.cssText = "text-align: center;line-height: 1.2rem;color:#02A8A2;font-size: 0.16rem;font-weight: 600;";
      //    chart.removeAttribute('_echarts_instance_')
      //  })
      // }
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    getEchartData2() {
      const chart = this.$refs.chart2;
      if (chart) {
        const myChart = this.$echarts.init(chart);
        const option = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255, 214, 0, .9)",
            borderColor: "rgba(255, 193, 33, .6)",
            borderWidth: 2,
            textStyle: {
              color: "#fff",
              fontSize: 10,
            },
            formatter: (params) => {
              let dataStr = `<div><p style="font-weight:bold;margin:4px 0;text-align: center;">${params[0].name}</p></div>`;
              params.forEach((item) => {
                dataStr += `
        <div>
          <div style="text-align: center;margin-bottom:4px;">
            <span style="display:inline-block;margin-right:6px;">${item.seriesName}:</span>
            <span>${item.data}</span>
          </div>
        </div>`;
              });
              return dataStr;
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "3%",
            top: "5%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
            boundaryGap: false,
            data: this.dateA,
          },
          yAxis: {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
          },
          series: [
            {
              name: "观众人数",
              smooth: true,
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(41, 241, 156, 1)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(2, 161, 249, 1)", // 100% 处的颜色
                    },
                  ],
                },
                width: 3,
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(41, 241, 156, 1)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 255, 246, 0)", // 100% 处的颜色
                    },
                  ],
                },
              },
              type: "line",
              stack: "Total",
              showSymbol: false,
              symbolSize: 10,
              symbol:
                "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAT3SURBVHgBlVfdblRVFP72YQqtUBgtSmqiPVXxzjAQr/Si03iniZQnaGuMeNfxCaZ9gnaeoOXSK4rxJ0RsZxK90AscDBmQaDtVAw0RGH4Klc7M8tt7n3P2PtOhtDtZPaf7rLW+9b/3KOxiya/IIoMcenAaLeQhKkSbe8KPbTT4rEKEhIp6F4u70ameC9gbTEHaBbISiEhtimhAC2qfrUigbb7XubmATZxTo6jvGViuE7At03zN2g1NYsFiQAOu3P/+s03QlswQfGHXwFILZvm3YLVEHqojwAC3Do4APSGwP7TMzQbwpArcvQD8yyhvriGJjDFA5tQH+ALPW3IN81KjaEw3QpFHy7LrtT4v8jNlykrkB9IlTZjfGbSGWamR0RBB16dEWvdkz2uLMjcKFvR70kVomu0OehUTck05T29Pb1e4sSxyc4JKh0V+I29V8+dEVrh39/x2/j+LBCTPd9T3LZ9fB4VUjlm9IQ5gma+h2X2J3495Bm7VgVuTwEaZzMpWsc5fS6L3KJ8Zir+zBPSGTvY607tashUvbL0mhtUZNALzsRfjCWhmGHi56AQ3WTgrJwla6QDVpCxoKzLiMQ38hbwPq07+zaI1xBindIcUnMc1tWqAdfW+yjrIjjtPV05RoBFXqPMwBjMKxRminwH1v3cZ6LO+4E4Z+Gk0mgHSwH0MB8znWAKqQxWD6rU2GoFG/dtSztu2Z0DTi4TmfUqZ6qTTM5AH9r0Yt1kWh5ALyJy3Tc8/h0475kfsy601NzSSEKsot94w8Y2Ivb5dZl+Xnb43ptzUa2GMOVYnEsHDHvCDRS+XcGBJqElNby+mJB2k+jmn7+iIm2rASIYvuWT89eUc45MrnoexQpU2pvO9jXTu18tO3wuhH50wIGA2sWRf1jE+rnrhFGeAH+aklaQjOlE6Hqw5fQdDb8ZLNmP7K4q9v5J2kQ6PVEcPd0QizmNskL+8wyUwTR17/J9n4b6hdLEkIeworFR+I54490e81OlKF4mN4gDR52es5OmqF5p82osWupDanmufP3vS6btXRdI9HLYElkpSXPcrjvHouCuSlEfetGrH371I+OCvf+z0/XXBOypxJSDTYhK6myXHeDgP9Oe9NvJz2llsylHsva7ioTGn7+9F/6JQDnhF4V1J2TzrPDTKjvnteXPjSbzUgk3lFZ3yRqZX2RnKfLjk9PzBfn64FoVZ1dWnWAx4NWlQqBSdHsDvn9hbhV56uJ9asrM31a+dPe2FP8PR+BFl+kNXVNVp+02MkWaq2NOpiTlzW4xPmNUZZ20/K/N9DvwDQ10qGOn8vpIHzpB3wKvm6oz11hZWnVgLeju5c8kyjyvhLUEiT4aL9kjz1y0WyD/M1R19x6paT/to0DECvsViHMyn+TXo5ZmojczJNKk+6wA24JfouWAqmd1DHOzHizZne1kmvAS8OucPk5L6HOkbSAr8Ii0SXgziCdRLj45PA6+NY1dLz+cfJ+24jD1lXtVZTPhsqpusfBPQ8/ZUJGQt1iEdZHsM8gTLMoc9URQ26jxCSesVoMZ23Gx4gEZbieEtdGJ0BTbsX9FCUUV6Hdr+E28OR60Tz/i40pNfGeadLcoL/Vmmr8t6JrABP29AJ/iqQx8i9QsiosSg2BjdHShhP+bUJBrP0r0jcMqIL3lFEnNbOUHFOXOcWq/18KkTuGKmYAbVnQDj9T+bbcQkG9RYnAAAAABJRU5ErkJggg==",
              data: this.overView.visitor,
            },
          ],
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    getEchartData3() {
      const chart = this.$refs.chart3;
      if (chart) {
        const myChart = this.$echarts.init(chart);
        const option = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255, 214, 0, .9)",
            borderColor: "rgba(255, 193, 33, .6)",
            borderWidth: 2,
            textStyle: {
              color: "#fff",
              fontSize: 10,
            },
            formatter: (params) => {
              let dataStr = `<div><p style="font-weight:bold;margin:4px 0;text-align: left;">${params[0].name}</p></div>`;
              params.forEach((item) => {
                dataStr += `
        <div>
          <div style="text-align: left;margin-bottom:4px;">
            <span style="display:inline-block;margin-right:6px;">${item.seriesName}:</span>
            <span>${item.data}</span>
          </div>
        </div>`;
              });
              return dataStr;
            },
          },
          legend: {
            itemHeight: 10,
            itemWidth: 10,
            itemGap: 28,
            selectedMode: false,
            data: [
              {
                name: "新增粉丝数",
                icon: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMlSURBVHgBZVbNbZQxEPUYgzggQTpICVAACsmNLtJBOFLGIhqAKxISR24kHdDBLqdIXMgNWNszzK/tL6y08bf25zdv3jyPA8k/b/b7Z4+ePL7KlF5RSmeQEiQASkRAPNE7UG8AvfNzA/mdWov5BM3mvrcKu89nJx8DF+TP29vbU3gI3wjplLFIF4CXJrh9a0pNAAOcgXE8e1ALeKgtXXx9fXKwAD9v9zycWkhnnWy0DZAYCHhjsNYRe9YxgjIBzdCD/DhWevGAwS8Z9lIZO3gk1w0UTBoQxjzHoHXJqum8vePBjEx+Sg3+Fga+ItYBSZEVXGWRTQEqICjpJxrzDm7sk4J3zLxOY53fPyuM+9yLoeDI6qAWTVj+V9BVZwEir4UHtGKjyqTZnpW0fCQHHI5YZLCvgY7AOgI2WAMIKPm6vltCkkRgUR18MlM2mpWn7YHi/cWqOopEIpUFHQFCjkgfh1O8iD1p6rOYG/nAiY1RCSJQQbTUhtUULJOBRy0s8KyNFdMPF8l7IVEz9kpQMxhSYFiOInVlEwSmowREnWLukeCVZs3aMsd7y+oA094siX1qO225kSZ8P+V1Wex9xYNiGkLqba2D6b0pNEti9YigcWIJohYCjuae0U6KaGYazqIthwxCU1vn2kRwbyGzfWxkhDBLQe4fDaMjeorCSk4la43D+6BZ9OWMiHuwwXIg02gX4bZSxS3onu5ri9BGtxR4ug1nj9qsR9sYjZHxCoaP7WhTmwcF9FDZ5pGFbJZmp+7yAo/WgZ5tc7NIgLo6ZThmjA5+zykdllO+2e+uyqMBag0wJDCbzqKaw7bNr1uhx6n1gnItJGMLWMOFkDJPXLcNGxhdUjujASz9P3nhgTZdNM6NXTrjCs3tSDfGRMDGnQvrFdjqtKX+bkakNT9DfAnpWl3uELFzo3c55bzjTYfm+rahI4xnHL0+xQjuJidA7jKWryoBCbz/8758yF/OT+7wN53zpoNehS1PO0om1SVyts5+Bqx8VjDuZr8jmHCux4vxX0V8Xn76ddlruWL2z9vq/9mjVOP7a1POdM0Bb46l7NIO7gTzHylXoX66x8K5AAAAAElFTkSuQmCC",
              },
              {
                name: "总计粉丝数",
                icon: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKgSURBVHgBdVXBcVQxDNVb/iE3KGGHCqCCJbnRBQ0wDJ2EEmiBBpJUEA4M1ywdcGOYxFZkWZJl72ZnPf9/j/0kPT1JIPvxPb2hC/oirx9kHWRB/kzM0AOVWBZkybtsVSZ9ZzlTZJ/1+6esaxzou+PCwPd0gRs5tCfIhbAq4O1Llxwt3AEVXL8R+9XONUcKjvTIV/hIx27gNz2Irb2egHntz9oA9SLCa18NsOiTJ4OVW1R/6B+9f8W/6JNclYUB3gMz0LaARMlsoBtpwLC9TiXTa/n6v9FOeVc+ZNOQ2S65t9yBuXnGmAxohLan+fAoFOcAoWdw7uiFkDilSKwaUG/NUIuYaDIakWnyaRu4Tkt4s3ifDbMrKUWJvt8pCpwtKYYmr5ktgejK4IWGyWM47zlCvbs55SecsnnUkzui6tTQlPRh0COER70FFY3fITWegOuazFR0TF0cg3/OAtlelF8cSt7GCicQVE73oiibgUgQpoPOfV34zkbCsajsTnjHaLWDXXhYpsuj/FfA6ipxZSUHKPcrjUbKzMv8HD1lahUGjlETJ1HBHB01so2k0pChc9ylCes3lLrmqh4a6qGJ2i3J07jkITXnNWSM1LbP5MadS71rWxJm3htIIQ7Po6pTRCtwa3glFakaYGSljCdHZGkmLNVezzTAKZKW5KhMeN9hV4CFad+cCi76jewDVmweIaf+1QzQbb/Mud0OKZ4MGkv8ZKTRhjE+dfUR2gzcJT5h3mKSZkwt+86q6/XgtYNFst/ANzLsC93L2g8lLf2ppiRPvckjmUTidfSAz/R2h0v6S490KQeOA0ApY02wesU08pJntFE2D6Y2WI70RFettG3K9B//kNnMMkIrvUtJp0iyq6OstRMGbmX/TsCv8VUcl98zIPn0hL8DSJAAAAAASUVORK5CYII=",
              },
            ],
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "3%",
            top: "15%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
            data: this.dateA,
          },
          yAxis: {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
          },
          series: [
            {
              name: "新增粉丝数",
              smooth: true,
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(41, 241, 156, 1)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(2, 161, 249, 1)", // 100% 处的颜色
                    },
                  ],
                },
                width: 3,
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(41, 241, 156, 1)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 255, 246, 0)", // 100% 处的颜色
                    },
                  ],
                },
              },
              type: "line",
              showSymbol: false,
              symbolSize: 10,
              symbol:
                "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAT3SURBVHgBlVfdblRVFP72YQqtUBgtSmqiPVXxzjAQr/Si03iniZQnaGuMeNfxCaZ9gnaeoOXSK4rxJ0RsZxK90AscDBmQaDtVAw0RGH4Klc7M8tt7n3P2PtOhtDtZPaf7rLW+9b/3KOxiya/IIoMcenAaLeQhKkSbe8KPbTT4rEKEhIp6F4u70ameC9gbTEHaBbISiEhtimhAC2qfrUigbb7XubmATZxTo6jvGViuE7At03zN2g1NYsFiQAOu3P/+s03QlswQfGHXwFILZvm3YLVEHqojwAC3Do4APSGwP7TMzQbwpArcvQD8yyhvriGJjDFA5tQH+ALPW3IN81KjaEw3QpFHy7LrtT4v8jNlykrkB9IlTZjfGbSGWamR0RBB16dEWvdkz2uLMjcKFvR70kVomu0OehUTck05T29Pb1e4sSxyc4JKh0V+I29V8+dEVrh39/x2/j+LBCTPd9T3LZ9fB4VUjlm9IQ5gma+h2X2J3495Bm7VgVuTwEaZzMpWsc5fS6L3KJ8Zir+zBPSGTvY607tashUvbL0mhtUZNALzsRfjCWhmGHi56AQ3WTgrJwla6QDVpCxoKzLiMQ38hbwPq07+zaI1xBindIcUnMc1tWqAdfW+yjrIjjtPV05RoBFXqPMwBjMKxRminwH1v3cZ6LO+4E4Z+Gk0mgHSwH0MB8znWAKqQxWD6rU2GoFG/dtSztu2Z0DTi4TmfUqZ6qTTM5AH9r0Yt1kWh5ALyJy3Tc8/h0475kfsy601NzSSEKsot94w8Y2Ivb5dZl+Xnb43ptzUa2GMOVYnEsHDHvCDRS+XcGBJqElNby+mJB2k+jmn7+iIm2rASIYvuWT89eUc45MrnoexQpU2pvO9jXTu18tO3wuhH50wIGA2sWRf1jE+rnrhFGeAH+aklaQjOlE6Hqw5fQdDb8ZLNmP7K4q9v5J2kQ6PVEcPd0QizmNskL+8wyUwTR17/J9n4b6hdLEkIeworFR+I54490e81OlKF4mN4gDR52es5OmqF5p82osWupDanmufP3vS6btXRdI9HLYElkpSXPcrjvHouCuSlEfetGrH371I+OCvf+z0/XXBOypxJSDTYhK6myXHeDgP9Oe9NvJz2llsylHsva7ioTGn7+9F/6JQDnhF4V1J2TzrPDTKjvnteXPjSbzUgk3lFZ3yRqZX2RnKfLjk9PzBfn64FoVZ1dWnWAx4NWlQqBSdHsDvn9hbhV56uJ9asrM31a+dPe2FP8PR+BFl+kNXVNVp+02MkWaq2NOpiTlzW4xPmNUZZ20/K/N9DvwDQ10qGOn8vpIHzpB3wKvm6oz11hZWnVgLeju5c8kyjyvhLUEiT4aL9kjz1y0WyD/M1R19x6paT/to0DECvsViHMyn+TXo5ZmojczJNKk+6wA24JfouWAqmd1DHOzHizZne1kmvAS8OucPk5L6HOkbSAr8Ii0SXgziCdRLj45PA6+NY1dLz+cfJ+24jD1lXtVZTPhsqpusfBPQ8/ZUJGQt1iEdZHsM8gTLMoc9URQ26jxCSesVoMZ23Gx4gEZbieEtdGJ0BTbsX9FCUUV6Hdr+E28OR60Tz/i40pNfGeadLcoL/Vmmr8t6JrABP29AJ/iqQx8i9QsiosSg2BjdHShhP+bUJBrP0r0jcMqIL3lFEnNbOUHFOXOcWq/18KkTuGKmYAbVnQDj9T+bbcQkG9RYnAAAAABJRU5ErkJggg==",
              data: this.overView.new_fans,
            },
            {
              name: "总计粉丝数",
              smooth: true,
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(255, 214, 0, 1)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(255, 143, 0, 1)", // 100% 处的颜色
                    },
                  ],
                },
                width: 3,
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(255, 228, 86, 0.3)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(255, 193, 33, 0)", // 100% 处的颜色
                    },
                  ],
                },
              },
              type: "line",
              showSymbol: false,
              symbolSize: 10,
              symbol:
                "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAT3SURBVHgBlVfdblRVFP72YQqtUBgtSmqiPVXxzjAQr/Si03iniZQnaGuMeNfxCaZ9gnaeoOXSK4rxJ0RsZxK90AscDBmQaDtVAw0RGH4Klc7M8tt7n3P2PtOhtDtZPaf7rLW+9b/3KOxiya/IIoMcenAaLeQhKkSbe8KPbTT4rEKEhIp6F4u70ameC9gbTEHaBbISiEhtimhAC2qfrUigbb7XubmATZxTo6jvGViuE7At03zN2g1NYsFiQAOu3P/+s03QlswQfGHXwFILZvm3YLVEHqojwAC3Do4APSGwP7TMzQbwpArcvQD8yyhvriGJjDFA5tQH+ALPW3IN81KjaEw3QpFHy7LrtT4v8jNlykrkB9IlTZjfGbSGWamR0RBB16dEWvdkz2uLMjcKFvR70kVomu0OehUTck05T29Pb1e4sSxyc4JKh0V+I29V8+dEVrh39/x2/j+LBCTPd9T3LZ9fB4VUjlm9IQ5gma+h2X2J3495Bm7VgVuTwEaZzMpWsc5fS6L3KJ8Zir+zBPSGTvY607tashUvbL0mhtUZNALzsRfjCWhmGHi56AQ3WTgrJwla6QDVpCxoKzLiMQ38hbwPq07+zaI1xBindIcUnMc1tWqAdfW+yjrIjjtPV05RoBFXqPMwBjMKxRminwH1v3cZ6LO+4E4Z+Gk0mgHSwH0MB8znWAKqQxWD6rU2GoFG/dtSztu2Z0DTi4TmfUqZ6qTTM5AH9r0Yt1kWh5ALyJy3Tc8/h0475kfsy601NzSSEKsot94w8Y2Ivb5dZl+Xnb43ptzUa2GMOVYnEsHDHvCDRS+XcGBJqElNby+mJB2k+jmn7+iIm2rASIYvuWT89eUc45MrnoexQpU2pvO9jXTu18tO3wuhH50wIGA2sWRf1jE+rnrhFGeAH+aklaQjOlE6Hqw5fQdDb8ZLNmP7K4q9v5J2kQ6PVEcPd0QizmNskL+8wyUwTR17/J9n4b6hdLEkIeworFR+I54490e81OlKF4mN4gDR52es5OmqF5p82osWupDanmufP3vS6btXRdI9HLYElkpSXPcrjvHouCuSlEfetGrH371I+OCvf+z0/XXBOypxJSDTYhK6myXHeDgP9Oe9NvJz2llsylHsva7ioTGn7+9F/6JQDnhF4V1J2TzrPDTKjvnteXPjSbzUgk3lFZ3yRqZX2RnKfLjk9PzBfn64FoVZ1dWnWAx4NWlQqBSdHsDvn9hbhV56uJ9asrM31a+dPe2FP8PR+BFl+kNXVNVp+02MkWaq2NOpiTlzW4xPmNUZZ20/K/N9DvwDQ10qGOn8vpIHzpB3wKvm6oz11hZWnVgLeju5c8kyjyvhLUEiT4aL9kjz1y0WyD/M1R19x6paT/to0DECvsViHMyn+TXo5ZmojczJNKk+6wA24JfouWAqmd1DHOzHizZne1kmvAS8OucPk5L6HOkbSAr8Ii0SXgziCdRLj45PA6+NY1dLz+cfJ+24jD1lXtVZTPhsqpusfBPQ8/ZUJGQt1iEdZHsM8gTLMoc9URQ26jxCSesVoMZ23Gx4gEZbieEtdGJ0BTbsX9FCUUV6Hdr+E28OR60Tz/i40pNfGeadLcoL/Vmmr8t6JrABP29AJ/iqQx8i9QsiosSg2BjdHShhP+bUJBrP0r0jcMqIL3lFEnNbOUHFOXOcWq/18KkTuGKmYAbVnQDj9T+bbcQkG9RYnAAAAABJRU5ErkJggg==",
              data: this.overView.total_fans,
            },
          ],
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    getEchartData4() {
      const chart = this.$refs.chart4;
      if (chart) {
        const myChart = this.$echarts.init(chart);
        const option = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255, 214, 0, .9)",
            borderColor: "rgba(255, 193, 33, .6)",
            borderWidth: 2,
            textStyle: {
              color: "#fff",
              fontSize: 10,
            },
            formatter: (params) => {
              let dataStr = `<div><p style="font-weight:bold;margin:4px 0;text-align: center;">${params[0].name}</p></div>`;
              params.forEach((item) => {
                dataStr += `
        <div>
          <div style="text-align: center;margin-bottom:4px;">
            <span style="display:inline-block;margin-right:6px;">${item.seriesName}:</span>
            <span>${item.data}</span>
          </div>
        </div>`;
              });
              return dataStr;
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "3%",
            top: "5%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              data: this.dateA,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#999",
                },
              },
              axisTick: {
                show: true,
                lineStyle: {
                  color: "#999",
                },
              },
              splitLine: {
                show: true,
                lineStyle: {
                  type: "dashed",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#999",
                },
              },
              axisTick: {
                show: true,
                lineStyle: {
                  color: "#999",
                },
              },
              splitLine: {
                show: true,
                lineStyle: {
                  type: "dashed",
                },
              },
            },
          ],
          series: [
            {
              name: "直播场次",
              type: "bar",
              itemStyle: {
                borderRadius: [5, 5, 0, 0],
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(41, 241, 156, 1)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(2, 161, 249, 1)", // 100% 处的颜色
                    },
                  ],
                },
              },
              barWidth: 12,
              data: this.overView.times,
            },
          ],
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    getEchartData5() {
      const chart = this.$refs.chart5;
      if (chart) {
        const myChart = this.$echarts.init(chart);
        const option = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255, 214, 0, .9)",
            borderColor: "rgba(255, 193, 33, .6)",
            borderWidth: 2,
            textStyle: {
              color: "#fff",
              fontSize: 10,
            },
            formatter: (params) => {
              let dataStr = `<div><p style="font-weight:bold;margin:4px 0;text-align: center;">${params[0].name}</p></div>`;
              params.forEach((item) => {
                dataStr += `
        <div>
          <div style="text-align: center;margin-bottom:4px;">
            <span style="display:inline-block;margin-right:6px;">${item.seriesName}:</span>
            <span>${item.data}</span>
          </div>
        </div>`;
              });
              return dataStr;
            },
          },
          grid: {
            left: "4%",
            right: "5%",
            bottom: "1%",
            top: "8%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
            boundaryGap: false,
            data: this.overView.date,
          },
          yAxis: {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "#999",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
          },
          series: [
            {
              name: this.toolTipText,
              smooth: true,
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(41, 241, 156, 1)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(2, 161, 249, 1)", // 100% 处的颜色
                    },
                  ],
                },
                width: 3,
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(41, 241, 156, 1)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 255, 246, 0)", // 100% 处的颜色
                    },
                  ],
                },
              },
              type: "line",
              stack: "Total",
              showSymbol: false,
              symbolSize: 10,
              symbol:
                "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAT3SURBVHgBlVfdblRVFP72YQqtUBgtSmqiPVXxzjAQr/Si03iniZQnaGuMeNfxCaZ9gnaeoOXSK4rxJ0RsZxK90AscDBmQaDtVAw0RGH4Klc7M8tt7n3P2PtOhtDtZPaf7rLW+9b/3KOxiya/IIoMcenAaLeQhKkSbe8KPbTT4rEKEhIp6F4u70ameC9gbTEHaBbISiEhtimhAC2qfrUigbb7XubmATZxTo6jvGViuE7At03zN2g1NYsFiQAOu3P/+s03QlswQfGHXwFILZvm3YLVEHqojwAC3Do4APSGwP7TMzQbwpArcvQD8yyhvriGJjDFA5tQH+ALPW3IN81KjaEw3QpFHy7LrtT4v8jNlykrkB9IlTZjfGbSGWamR0RBB16dEWvdkz2uLMjcKFvR70kVomu0OehUTck05T29Pb1e4sSxyc4JKh0V+I29V8+dEVrh39/x2/j+LBCTPd9T3LZ9fB4VUjlm9IQ5gma+h2X2J3495Bm7VgVuTwEaZzMpWsc5fS6L3KJ8Zir+zBPSGTvY607tashUvbL0mhtUZNALzsRfjCWhmGHi56AQ3WTgrJwla6QDVpCxoKzLiMQ38hbwPq07+zaI1xBindIcUnMc1tWqAdfW+yjrIjjtPV05RoBFXqPMwBjMKxRminwH1v3cZ6LO+4E4Z+Gk0mgHSwH0MB8znWAKqQxWD6rU2GoFG/dtSztu2Z0DTi4TmfUqZ6qTTM5AH9r0Yt1kWh5ALyJy3Tc8/h0475kfsy601NzSSEKsot94w8Y2Ivb5dZl+Xnb43ptzUa2GMOVYnEsHDHvCDRS+XcGBJqElNby+mJB2k+jmn7+iIm2rASIYvuWT89eUc45MrnoexQpU2pvO9jXTu18tO3wuhH50wIGA2sWRf1jE+rnrhFGeAH+aklaQjOlE6Hqw5fQdDb8ZLNmP7K4q9v5J2kQ6PVEcPd0QizmNskL+8wyUwTR17/J9n4b6hdLEkIeworFR+I54490e81OlKF4mN4gDR52es5OmqF5p82osWupDanmufP3vS6btXRdI9HLYElkpSXPcrjvHouCuSlEfetGrH371I+OCvf+z0/XXBOypxJSDTYhK6myXHeDgP9Oe9NvJz2llsylHsva7ioTGn7+9F/6JQDnhF4V1J2TzrPDTKjvnteXPjSbzUgk3lFZ3yRqZX2RnKfLjk9PzBfn64FoVZ1dWnWAx4NWlQqBSdHsDvn9hbhV56uJ9asrM31a+dPe2FP8PR+BFl+kNXVNVp+02MkWaq2NOpiTlzW4xPmNUZZ20/K/N9DvwDQ10qGOn8vpIHzpB3wKvm6oz11hZWnVgLeju5c8kyjyvhLUEiT4aL9kjz1y0WyD/M1R19x6paT/to0DECvsViHMyn+TXo5ZmojczJNKk+6wA24JfouWAqmd1DHOzHizZne1kmvAS8OucPk5L6HOkbSAr8Ii0SXgziCdRLj45PA6+NY1dLz+cfJ+24jD1lXtVZTPhsqpusfBPQ8/ZUJGQt1iEdZHsM8gTLMoc9URQ26jxCSesVoMZ23Gx4gEZbieEtdGJ0BTbsX9FCUUV6Hdr+E28OR60Tz/i40pNfGeadLcoL/Vmmr8t6JrABP29AJ/iqQx8i9QsiosSg2BjdHShhP+bUJBrP0r0jcMqIL3lFEnNbOUHFOXOcWq/18KkTuGKmYAbVnQDj9T+bbcQkG9RYnAAAAABJRU5ErkJggg==",
              data: this.fans,
            },
          ],
        };
      // if(this.overView.date.length == 0) {
      //  this.$nextTick(() => {
      //    chart.innerHTML = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;暂无数据";
      //    chart.style.cssText = "text-align: center;line-height: 2.64rem;color:#02A8A2;font-size: 0.16rem;font-weight: 600;";
      //    chart.removeAttribute('_echarts_instance_')
      //  })
      // }
      myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }

      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.center-anchor-up {
  background-color: #fff;
  flex: 1;
  .anchor-titles {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.3rem;
    .title {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-right: 0.01rem solid #f0f0f0;
      cursor: pointer;
      &:last-child {
        border-right: none;
      }
      img {
        width: 0.36rem;
        height: 0.36rem;
        margin-bottom: 0.12rem;
      }
      span {
        font-size: 0.16rem;
        line-height: 0.22rem;
        font-weight: 500;
      }
    }
    .active {
      span {
        font-weight: 600;
      }
    }
  }
}
.center-anchor {
  background-color: #fff;
  border-top: 0.08rem solid #f4f4f4;
  padding: 0.3rem 0.44rem 0.44rem;
  flex: 1;
  .dataOverview-up-title {
    height: 0.37rem;
    border-bottom: 0.01rem solid #f0f0f0;
    color: #333;
    font-size: 0.16rem;
    font-weight: 500;
    line-height: 0.36rem;
  }
  .dataOverview-up-content {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    padding: 0.2rem 0 0.36rem;
    .content {
      display: flex;
      width: 2.50rem;
      height: 0.8rem;
      border-radius: 0.05rem;
      padding: 0.18rem 0.30rem;
      margin-top: .15rem;
      margin-right: .15rem;
      cursor: pointer;
      img {
        height: 0.52rem;
        width: 0.52rem;
      }
      .content-text {
        display: flex;
        flex-direction: column;
        margin-left: 0.2rem;
        .content-text-title {
          margin-top: 0.04rem;
          font-size: 0.14rem;
          color: #666;
        }
        .content-text-num {
          margin-top: 0.06rem;
          font-size: 0.22rem;
          font-weight: 700;
          color: #333;
        }
      }
    }
  }
  .dataOverview-down {
    .dataOverview-down-title {
      height: 0.37rem;
      border-bottom: 0.01rem solid #f0f0f0;
      .left {
        float: left;
        color: #333;
        font-size: 0.16rem;
        font-weight: 500;
        line-height: 0.36rem;
      }
      .right {
        float: right;
      }
      .el-range-editor--mini.el-input__inner {
        width: 2.2rem;
      }
    }
    .dataOverview-down-content {
      padding-top: 0.2rem;
      .down-content-item-box {
        display: flex;
        justify-content: space-around;
        .down-content-item {
          position: relative;
          width: 4.43rem;
          height: 3.15rem;
          background: url(../../assets/img/center-anchor/chart_bg.png) no-repeat;
          background-size: 4.43rem 3.15rem;
          .charts-title {
            position: absolute;
            left: 50%;
            top: 5.5%;
            transform: translateX(-50%);
            font-weight: 500;
            font-size: 0.14rem;
            line-height: 0.09rem;
            color: #ffffff;
          }
          .charts {
            padding: 0.7rem 0.2rem 0.3rem;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .myFans-box {
    border-radius: 0.05rem;
    background-color: #fff;
    border-top: 0.02rem solid;
    border-image: linear-gradient(to right, #29f19c, #02a1f9) 1;
    box-shadow: 0rem 0.1rem 0.16rem #f0f0f0;
    padding: 0.24rem 0.3rem;
    padding-right: 0.1rem;
    .myFans-up {
      .myFans-up-left {
        display: flex;
        span {
          width: 0.64rem;
          height: 0.22rem;
          margin-right: 0.12rem;
          border: 0.01rem solid #dbdbdb;
          color: #999999;
          border-radius: 0.05rem;
          text-align: center;
          line-height: 0.22rem;
          cursor: pointer;
        }
        .active {
          border: none;
          color: #fff;
          background: #02a8a2;
        }
      }
      .myFans-up-right {
        float: right;
        margin-right: 0.36rem;
        margin-top: -0.24rem;
      }
      .el-range-editor--mini.el-input__inner {
        width: 2.2rem;
      }
    }
    .myFans-down {
      width: 100%;
      height: 2.64rem;
      .charts5 {
        width: 100%;
        height: 100%;
      }
    }
  }
  .frequency-box {
    border-radius: 0.05rem;
    background-color: #fff;
    border-top: 0.02rem solid;
    border-image: linear-gradient(to right, #29f19c, #02a1f9) 1;
    box-shadow: 0rem 0.1rem 0.16rem #f0f0f0;
    padding: 0.24rem 0.3rem;
    .frequency-up {
      float: right;
      margin-bottom: 0.24rem;
    }
    .el-range-editor--mini.el-input__inner {
      width: 2.2rem;
    }
    .frequency-down {
      width: 100%;
      margin: 0.3rem 0;
      .el-table {
        border-radius: 0.05rem;
        ::v-deep .el-table__row {
          height: 0.72rem;
        }
      }
    }
  }
}
</style>
